// src/pages/ramadan/RamadanHome.jsx
import React from 'react';

const RamadanHome = () => {
  return (
    <div style={{ padding: '2rem' }}>
      <h1>Ramadan Home</h1>
      <p>This is a placeholder page for the Ramadan (Muslim Religion Festival) module.</p>
    </div>
  );
};

export default RamadanHome;